<div [dir]="data.dir">
  <mat-label class="font-weight-bold">{{ "forms.common.Criteria.summary" | translate }} </mat-label>
  <mat-form-field appearance="outline">
    <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="data.summary" required
      [disabled]="data.isViewOnly"></textarea>
  </mat-form-field>

  <ng-container *ngIf="data.memberArabicName">
    <mat-label class="font-weight-bold">{{ "forms.common.Criteria.Member" | translate }} </mat-label>
    <mat-form-field appearance="outline">
      <input matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [disabled]="data.isViewOnly"
        value="{{ data | propertyLocalized : ['memberArabicName', 'memberEnglishName' ] | async}}" />
    </mat-form-field>
  </ng-container>

  <div class="d-flex justify-content-end">
    <button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.isViewOnly}">
      {{ "forms.common.cancel" | translate }}
    </button>
    <button *ngIf="!data.isViewOnly" mat-flat-button (click)="save()" color="primary" [disabled]="!data.summary">
      {{ "forms.common.Criteria.save" | translate }}
    </button>
  </div>
</div>
